import { render, staticRenderFns } from "./ProductDetailSubMenu.vue?vue&type=template&id=838e980a&scoped=true"
import script from "./ProductDetailSubMenu.vue?vue&type=script&lang=js"
export * from "./ProductDetailSubMenu.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailSubMenu.vue?vue&type=style&index=0&id=838e980a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838e980a",
  null
  
)

export default component.exports